import { StepIconProps, styled } from "@platform/style";
import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowPointer,
  faBriefcase,
  faClipboardUser,
  faGears,
  faPeopleGroup,
} from "@fortawesome/sharp-regular-svg-icons";

const StyledStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#EFEFEF",
  width: 50,
  height: 50,
  fontSize: "20px",
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  border: "solid",
  borderColor: "#979797",
  ...(ownerState.active && {
    border: "solid",
    borderColor: "#1460AA",
    backgroundImage: "linear-gradient( #C6E8F6 0%, #C6E8F6 0%, #C6E8F6 100%)",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient( #0074d9 0%, #0074d9 0%, #0074d9 100%)",
    border: "none",
  }),
}));

export function StyledStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const completedIconFillColor = "#050505";
  const icons: { [index: string]: React.ReactElement } = {
    1: !completed ? (
      <FontAwesomeIcon icon={faArrowPointer} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faArrowPointer} />
    ),
    2: !completed ? (
      <FontAwesomeIcon icon={faBriefcase} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faBriefcase} />
    ),
    3: !completed ? (
      <FontAwesomeIcon icon={faPeopleGroup} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faPeopleGroup} />
    ),
    4: !completed ? (
      <FontAwesomeIcon icon={faClipboardUser} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faClipboardUser} />
    ),
    5: !completed ? (
      <FontAwesomeIcon icon={faGears} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faGears} />
    ),
  };

  return (
    <StyledStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </StyledStepIconRoot>
  );
}
